<script>
    import { onDestroy } from 'svelte';
    import { MateriaDTO } from "../../api/DTOS/Materia.dto.js";
    import { carrerasBasicas, materias } from "../../MainStore.js";

    let materia = new MateriaDTO();
    let materiasIdToIndex = new Map();
    let editando = false;

    const unsubscribe = materias.subscribe(materiasDTO => {
        materiasDTO.forEach((materiaDTO, index) => {
            materiasIdToIndex.set(materiaDTO.id, index);
        });
    });

    materias.actualizarDatos();

    const handleEliminar = async () => {
        await materias.borrar(materia);

        editando = false;
        materia = new MateriaDTO();
        materia.carrera = undefined;
    };
    const handleCancelar = () => {
        editando = false;
        materia = new MateriaDTO();
        materia.carrera = undefined;
    };
    const handleAgregarMateria = () => {
        if (editando) {
            materias.actualizar(materia)
        } else {
            materias.agregar(materia);
        }

        editando = false;
        materia = new MateriaDTO();
        materia.carrera = undefined;
    };
    const handleEditarMateria = materiaSeleccionada => {
        materia = materiaSeleccionada;
        materia.carrera = $carrerasBasicas.filter(carrera => carrera.id == materia.carrera.id)[0];
        editando = true;
    };

    onDestroy(unsubscribe);
</script>

<div class="card mt-2">
    <div class="card-header">
        Materias
    </div>
    <div class="card-body overflow-auto">
        <div class="row align-items-center">
            <div class="col-3">
                Nombre Materia
            </div>
            <div class="col-6">
                <input placeholder="Nombre materia" class="form-control" bind:value={materia.nombre}/>
            </div>
        </div>
        <div class="row mt-2 align-items-center">
            <div class="col-3">
                Carrera de la materia
            </div>
            <div class="col-6">
                <select class="custom-select" bind:value={materia.carrera}>
                    <option value={undefined} hidden>Elija una opcion</option>
                    {#each $carrerasBasicas as carrera}
                        <option value={carrera}>{carrera.nombre}</option>
                    {/each}
                </select>
            </div>
        </div>
        <div class="row justify-content-end mt-2">
            <div class="col-6 text-right">
                {#if editando}
                    <button class="btn btn-raised btn-danger mr-2" on:click={handleEliminar}>Eliminar</button>
                {/if}
                <button class="btn btn-raised btn-secondary mr-2" on:click={handleCancelar}>Cancelar</button>
                <button class="btn btn-raised btn-success" on:click={handleAgregarMateria}>{editando ? "Guardar" : "Agregar"}</button>
            </div>
        </div>
        <table class="table mt-4 tabla-item-seleccionable">
            <thead>
                <tr>
                    <th scope="col">Nombre</th>
                    <th scope="col">Carrera</th>
                </tr>
            </thead>
            <tbody>
                {#each $materias as materia}
                    <tr on:click={() => { handleEditarMateria(materia); }}>
                        <td>{materia.nombre}</td>
                        <td>{materia.carrera.nombre}</td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
</div>